/* Home (ADR-0212). A table page: the tiles, the filings as compact paths, the Needs-you grid. Tokens
   only: stylelint refuses a colour literal (ADR-0007). */

.page {
  grid-column: 1 / -1;
  /* The whole body, as a table page is. Without a row of its own this sat in the first, auto row and
     the receipt drawer (row 2 onwards) was laid out below the fold, where nothing in it could be
     reached: a figure on Home opened a receipt nobody could click. */
  grid-row: 1 / -1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  flex: 1 1 auto;
}

.basisLine {
  display: block;
  margin-top: 2px;
  color: var(--muted);
  font-size: var(--t-min);
}

.scopes {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 10px;
  color: var(--muted);
  font-size: var(--t-min);
}

/* A scope's tonnes are a figure, so ink and not the brand; the dotted underline says it opens its receipt. */
.scopeButton {
  padding: 0;
  border: 0;
  background: none;
  color: var(--ink);
  font: inherit;
  text-decoration: underline dotted var(--line-2);
  text-underline-offset: 3px;
  cursor: pointer;
}

.scopeButton:hover {
  color: var(--accent);
  text-decoration-color: currentcolor;
  text-decoration-style: solid;
}

/* **The filings share five column tracks** (alignment audit, 2026-11-03). Each filing used to be its own
   grid with `auto` columns for the date and the next step, so the path strip began at a different x in
   every row. The list owns the tracks and each filing is a subgrid of them: the names, the paths, the
   dates and the next steps start and end on the same lines in every row, and every strip has the same
   width, so its three stations are the same size. The first template is the per-row fallback for a
   browser without `subgrid`. */
.filings {
  display: grid;
  grid-template-columns: minmax(220px, 1.2fr) minmax(280px, 2fr) max-content max-content max-content;
  gap: 8px 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.filing {
  display: grid;
  grid-template-columns: minmax(220px, 1.2fr) minmax(280px, 2fr) max-content max-content max-content;
  grid-template-columns: subgrid;
  grid-column: 1 / -1;
  align-items: center;
  min-width: 0;
}

/* The date, the next step and any in-force label are right-aligned in their tracks. */
.filing > :nth-child(n + 3) {
  justify-self: end;
}

.filingLink {
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: var(--ink);
  text-decoration: none;
}

.filingName {
  font-weight: 600;
}

.filingMeta,
.filingDue,
.none {
  color: var(--muted);
  font-size: var(--t-min);
}

.none {
  margin: 0;
}

/* A chip that is a way in ("1 filing overdue"): no underline round the chip. */
.stepLink {
  display: inline-flex;
  text-decoration: none;
}

/* The next step of a filing, a chip that is also a control: the chip's own look, a focus ring, and a
   pointer. */
.stepButton {
  display: inline-flex;
  padding: 0;
  border: 0;
  border-radius: var(--radius-chip);
  background: none;
  cursor: pointer;
}

.stepButton:hover {
  filter: brightness(0.96);
}

.stepButton:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

/* The two lines under the due-date tile's figure: how far ahead it is, and what is already late. */
.dueLines {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.dueAhead {
  color: var(--muted);
}

@media (max-width: 760px) {
  .filings {
    grid-template-columns: minmax(0, 1fr);
  }

  .filing > :nth-child(n + 3) {
    justify-self: start;
  }
}

.unread {
  margin: 0 0 8px;
  padding: 8px 12px;
  border: 1px solid var(--warn);
  border-radius: var(--radius-chip);
  color: var(--ink);
  font-size: var(--t-body);
}
